module.exports = __webpack_public_path__ + "static/assets/5c74b2c74fb87685d69914f6af840bc2.jpg";